var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { HomeEstimatorService } from '../../services/home-estimator.service';
import { HomeEstimatorRequest } from '../../services/home-estimator.service';
import { EventEmitter } from '@angular/core';
import { HasSubscriptions } from '../has-subscriptions';
import { HomeEstimateRequest } from '../../services/home-estimator.service';
var HomeEstimatorComponent = /** @class */ (function (_super) {
    __extends(HomeEstimatorComponent, _super);
    function HomeEstimatorComponent(fb, homeEstimatorService, router) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.homeEstimatorService = homeEstimatorService;
        _this.router = router;
        _this.standalone = false;
        _this.homeEstimatorRequest = new HomeEstimatorRequest();
        _this.hasError = false;
        _this.onContactAgent = new EventEmitter();
        _this.homeEstimatorForm = _this.fb.group({
            streetNumber: ['', Validators.required],
            streetName: ['', Validators.required],
            unitNumber: [''],
            city: [''],
            streetDirection: ['']
        });
        return _this;
    }
    HomeEstimatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.homeEstimatorForm.valueChanges.subscribe(function (value) {
            _this.hasError = false;
        }));
    };
    HomeEstimatorComponent.prototype.getEstimate = function () {
        var _this = this;
        this.homeEstimatorRequest.streetName = this.homeEstimatorForm.controls['streetName'].value;
        this.homeEstimatorRequest.unitNumber = this.homeEstimatorForm.controls['unitNumber'].value;
        this.homeEstimatorRequest.streetDirection = this.homeEstimatorForm.controls['streetDirection'].value;
        this.homeEstimatorRequest.streetNumber = this.homeEstimatorForm.controls['streetNumber'].value;
        this.homeEstimatorRequest.location = this.homeEstimatorForm.controls['city'].value;
        this.homeEstimatorService.getSuggestions(this.homeEstimatorRequest).then(function (data) {
            if (data.result.length === 0) {
                _this.hasError = true;
            }
            else if (data.result.length === 1) {
                data.result[0].jurisdiction_Descp = data.result[0].jurisdiction_Descp.split(',')[0];
                _this.getEstimateForSuggestion(data.result[0]);
            }
            else {
                _this.suggestions = data.result.map(function (it) {
                    it.jurisdiction_Descp = it.jurisdiction_Descp.split(',')[0];
                    return it;
                });
            }
        }).catch(function (err) {
            _this.hasError = true;
        });
    };
    HomeEstimatorComponent.prototype.mapRequest = function (data) {
        var homeEstimateRequest = new HomeEstimateRequest();
        homeEstimateRequest.rollNumber = data.roll_Number;
        homeEstimateRequest.jurisdictionCode = data.jurisdiction_Code;
        homeEstimateRequest.assessmentAreaCode = data.assessmentArea_Code;
        return homeEstimateRequest;
    };
    HomeEstimatorComponent.prototype.editForm = function () {
        this.homeEstimate = null;
        this.hasError = false;
    };
    HomeEstimatorComponent.prototype.getEstimateForSuggestion = function (property) {
        var _this = this;
        this.homeEstimatorForm.controls['streetNumber'].patchValue(property.street_From);
        this.homeEstimatorForm.controls['streetName'].patchValue(property.street_Name);
        this.homeEstimatorForm.controls['unitNumber'].patchValue(property.apart_Suite);
        this.homeEstimatorForm.controls['streetDirection'].patchValue(property.street_Dir);
        this.homeEstimatorRequest.streetNumber = property.street_From;
        this.homeEstimatorRequest.streetName = property.street_Name;
        this.homeEstimatorRequest.streetDirection = property.street_Dir;
        this.homeEstimatorRequest.unitNumber = property.apart_Suite;
        var homeEstimateRequest = this.mapRequest(property);
        this.homeEstimatorService.getHomeEstimate(property).then(function (homeEstimate) {
            _this.setHomeEstimate(homeEstimate.result);
        });
    };
    HomeEstimatorComponent.prototype.setHomeEstimate = function (estimate) {
        this.suggestions = null;
        if (estimate.activeListingDetailUrl) {
            this.router.navigate([estimate.activeListingDetailUrl]);
            return;
        }
        this.homeEstimate = estimate;
    };
    HomeEstimatorComponent.prototype.closeSuggestions = function () {
        this.suggestions = null;
    };
    return HomeEstimatorComponent;
}(HasSubscriptions));
export { HomeEstimatorComponent };
